import React from "react";

import BillRow from "./BillRow";
import st from "lib/utils/index";
import * as FormControl from "lib/components/FormControl";
import DeleteRowButton from "./FormControl/DeleteRowButton";

export default class EditableBillRow extends React.PureComponent {
  handleChange(attr, value) {
    const { item, onChange } = this.props;

    return onChange({
      ...item,
      [attr]: value,
    });
  }

  render() {
    const { item, onBlur, onChange, onRemove, valid, className, defaultCurrency, ...rest } = this.props;

    const name = (
      <div className="u-positionRelative">
        <FormControl.Input
          type="text"
          value={item.name}
          onBlur={onBlur}
          onChange={(value) => this.handleChange("name", value)}
          placeholder={I18n.t("papp.components.EditableBillRow.placeholder")}
          fluid
          inputClassName="u-paddingRight"
        />
        {onRemove && <DeleteRowButton onClick={onRemove} />}
      </div>
    );

    const quantity = (
      <FormControl.Input
        type="number"
        value={item.quantity}
        onBlur={onBlur}
        onChange={(value) => this.handleChange("quantity", +value)}
      />
    );

    const unitPrice = (
      <FormControl.Money
        value={item.unit_price}
        onBlur={onBlur}
        onChange={(value) => this.handleChange("unit_price", value)}
        defaultCurrency={defaultCurrency}
      />
    );

    return (
      <BillRow
        className={[className || "", !valid ? "error" : ""].join(" ")}
        name={name}
        quantity={quantity}
        unitPrice={unitPrice}
        totalPrice={item.total_price && st.formatMoney(item.total_price)}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/EditableBillRow.jsx